import React from "react";
import { withTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../modal-new";
import { RillContext } from "../../rill/RillReact/share/base";
const id = "modal-add-faq";

class AddFaqModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { currentFaq = { answer: "", question: "" } } = this.context.locals;
    this.state = {
      question: this.props.isNew ? "" : currentFaq.question,
      answer: this.props.isNew ? "" : currentFaq.answer,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  }

  handleCancel(e) {
    e.preventDefault();
    submit("/actions/refresh", {
      method: "GET",
      body: { modal: "" },
    });
  }

  render() {
    const { isNew, t } = this.props;
    const { id = 0 } = this.context.locals.query;
    return (
      <Modal
        name={id}
        key={id}
        className="add-faq-modal"
        title={
          isNew
            ? t("addFaqModal.createTitle")
            : t("addFaqModal.editTitle")
        }
      >
        <div className="body">
          <div className="Add-Faq">
            <div className="group">
              <label>{t("addFaqModal.question")}</label>
              <textarea
                name="question"
                className="textarea-input"
                placeholder={t("addFaqModal.questionPlaceholder")}
                value={this.state.question}
                onChange={(evt) => this.handleInputChange(evt)}
                sz="large"
              />
            </div>
            <div className="group mt-6">
              <label>{t("addFaqModal.answer")}</label>
              <textarea
                name="answer"
                className="textarea-input"
                placeholder={t("addFaqModal.answerPlaceholder")}
                value={this.state.answer}
                onChange={(evt) => this.handleInputChange(evt)}
                sz="large"
              />
            </div>
          </div>
        </div>
        <footer>
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            onClick={this.handleCancel}
          >
            {t("common:cancel")}
          </a>
          <button
            type="submit"
            data-button-type="primary"
            onClick={() => {
              submit("#", {
                method: "POST",
                body: {
                  id,
                  isNew,
                  question: this.state.question,
                  answer: this.state.answer,
                },
              });
            }}
          >
            {t("addFaqModal.addQuestion")}
          </button>
        </footer>
      </Modal>
    );
  }
}

AddFaqModal.contextType = RillContext;

export { id };
export default withTranslation(["coaching-portal", "common"])(AddFaqModal);
